import React from 'react';
import { fetchPostQuery, useQueryPromise } from '/src/api';
import {
    useAuthContext,
    useCartContext,
    useModalsContext,
    useStoreConfigContext
} from '/src/providers';
import {
    Modal,
    Form,
    ButtonCheckout,
    useForm,
    Loader,
    H2
} from '/src/components';
import { CREATE_ACCOUNT } from '/src/consts';
import graphQLQueries from './graph-ql-queries';
import * as styles from './styles.scss';

const Vip = ({ isCheckout, email, setIsVip, setIsGuestContinue }) => {
    const { translate } = useStoreConfigContext();
    const { isAuth } = useAuthContext();
    const { hideModal, showModal, MODALS_TYPES } = useModalsContext();
    const { cart: { email: cartEmail } } = useCartContext();
    const { data: { vip }, handleChange } = useForm({ vip: false });

    const { isLoading, runQueryPromise ,setValues } = useQueryPromise({
        query: graphQLQueries.setVipStatusOpt,
        isMethodPost: true,
    });

    const handleSetIsVip = () => {
        if (isAuth) {
            runQueryPromise({
                variables: {
                    input: {
                        email,
                        value: true,
                    }
                }
            }).then(() => {
                setIsVip(true);
                showModal(MODALS_TYPES.SUCCESS);
            }).catch(errors => showModal(MODALS_TYPES.ERROR, { errors }));
        } else {
            if (isCheckout) {
                setValues({ isLoading: true });
                fetchPostQuery({
                    query: graphQLQueries.isEmailAvailable,
                    variables: {
                        email: cartEmail,
                    }
                }).then(({ isEmailAvailable: { is_email_available } }) => {
                    setValues({ isLoading: false });
                    const { password } = JSON.parse(sessionStorage.getItem(CREATE_ACCOUNT)) || {};

                    if (is_email_available && !password) {
                        showModal(MODALS_TYPES.VIP_CREATE_ACCOUNT, { setIsVip, setIsGuestContinue })
                    } else {
                        setIsVip(true);
                        showModal(MODALS_TYPES.SUCCESS);
                    }
                }).catch(errors => {
                    setValues({ isLoading: false });
                    showModal(MODALS_TYPES.ERROR, { errors })
                });
            } else {
                setIsVip(true);
                showModal(MODALS_TYPES.SUCCESS);
            }
        }
    };

    return (
        <Modal toggle={hideModal}>
            <Loader isLoading={isLoading}>
                <div className={styles.shad}>
                    <H2 className={styles.title}>{translate('Upgrade to a VIP member for FREE')}</H2>
                    <div className={styles.club}>
                        {translate('As a member of our VIP club, you will be able to access a huge range of exclusive benefits, at no extra cost')}
                    </div>
                    <div className={styles.bg}>
                        <ul className={styles.list}>
                            <li>{translate('Earn 4% of your order back in BWFO Cash (compared to 1%)')}</li>
                            <li>{translate('Get weekly exclusive offers for a free product by email')}</li>
                            <li>{translate('Exclusive special offers')}</li>
                            <li>{translate('Early access to seasonal sales')}</li>
                            <li>{translate('Get your order faster with prioritized deliveries')}</li>
                        </ul>
                    </div>
                    <div className={styles.club}>
                        {translate('Best of all it is completely FREE and always will be, with no joining fee or monthly cost.')}
                    </div>
                </div>
                <div className={styles.confirm}>
                    <Form.Checkbox
                        name="vip"
                        label={translate('I want to become a vip member for free')}
                        checked={vip}
                        onChange={handleChange}
                    />
                    <ButtonCheckout
                        onClick={handleSetIsVip}
                        disabled={!vip || isLoading}
                    >
                        {translate('Confirm')}
                    </ButtonCheckout>
                </div>
                <div className={styles.text}>
                    {translate('These benefits are not available to customers who are already wholesale customers. Our weekly offer emails for free products are sent out weekly on a Wednesday, and reminders are also sent on Sunday and Monday. We may at times send emails on a different day if there is a time limitation to allow you as much time as possible to claim the offer.')}
                </div>
            </Loader>
        </Modal>
    )
};

export default Vip;
